import axiosPost from "./axiosPost";

export const RNHZonaUpd = async (credentials, data) => {
    const body = {
        service: "RNHZonaUpd",
        params: {
            rnhZonaId: data?.id,
            rnhZonaCod: data?.cod,
            rnhZonaNombre: data?.name,
            rnhZonaWKT: data?.wkt,
            rnhZonaVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
